import { useEffect } from 'react'

// Apply the hemisphere / continent / population filters to the region fill and
// border layers via a MapLibre filter expression (or clear it when no filter).
export function useMapFilters(map, regionsData, filters) {
  useEffect(() => {
    if (!map.current || !regionsData || !map.current.getSource('regions')) return

    const filterExpression = ['all']

    if (filters.hemisphere) {
      filterExpression.push(['==', ['get', 'hemisphere'], filters.hemisphere])
    }

    if (filters.continent) {
      filterExpression.push(['==', ['get', 'continent'], filters.continent])
    }

    if (filters.minPopulation > 0 || filters.maxPopulation < 10000000) {
      if (filters.minPopulation > 0) {
        filterExpression.push(['>=', ['get', 'population'], filters.minPopulation])
      }
      if (filters.maxPopulation < 10000000) {
        filterExpression.push(['<=', ['get', 'population'], filters.maxPopulation])
      }
    }

    if (filterExpression.length > 1) {
      map.current.setFilter('regions-fill', filterExpression)
      map.current.setFilter('regions-border', filterExpression)
    } else {
      map.current.setFilter('regions-fill', null)
      map.current.setFilter('regions-border', null)
    }
  }, [map, filters, regionsData])
}
